import actionTypes from '../actions/types';
import PERFORNAMCE from '../config/performance';

const { DEPTH_LIMIT } = PERFORNAMCE;
const NONZERO_TEST = /[1-9]/;
const _makeOrder = ([price, total]) => [+price, total, +total]; // + parses floats, nums for sorting

export const INITIAL_STATE = {};

export const handleClearDepthData = (state, { symbol }) => (
  { ...state, books: { ...state.books, [symbol]: {} } }
);

export const handleUpdateDepthData = (state, { symbol, data }, isStreamed) => {
  const prevBook = state.books[symbol] || {};
  // do not update before book is fetched
  if (isStreamed && !prevBook.lastUpdateId) {
    if (__DEV__) {
      console.warn('Got streamed update before the book was fetched. ignoring.',
        symbol, prevBook.lastUpdateId, data.lastUpdateId);
    }
    return state;
  // do not apply old updates
  } if (data.lastUpdateId && prevBook.lastUpdateId &&
      data.lastUpdateId <= prevBook.lastUpdateId) {
    if (__DEV__) {
      console.warn('Got update behind book lastUpdateId. ignoring.',
        symbol, prevBook.lastUpdateId, data.lastUpdateId);
    }
    return state;
  }
  const newState = { ...state, books: { ...(state.books || {}) } };
  const book = newState.books[symbol] = { ...(state.books[symbol] || {}) };
  let updated = false;
  ['bids', 'asks'].forEach((type) => {
    let updatedSide = false;
    const newSide = data[type].reduce((side, pair) => {
      const [price, total] = pair;
      if (!NONZERO_TEST.test(total)) delete side[price];
      else side[price] = _makeOrder(pair);
      updatedSide = true;
      return side;
    }, { ...(book[type] || {}) });
    if (updatedSide) {
      if (type === 'bids') {
        const min = Math.min.apply(null, Object.keys(newSide).sort((a, b) => b - a).slice(0, DEPTH_LIMIT));
        Object.keys(newSide).forEach((f) => {
          if (Number(f) < min) { delete newSide[f]; }
        });
      } else if (type === 'asks') {
        const max = Math.max.apply(null, Object.keys(newSide).sort((a, b) => a - b).slice(0, DEPTH_LIMIT));
        Object.keys(newSide).forEach((f) => {
          if (Number(f) > max) { delete newSide[f]; }
        });
      }


      book[type] = newSide;
      updated = true;
    }
  });
  if (book.lastUpdateId !== data.lastUpdateId) {
    book.lastUpdateId = data.lastUpdateId;
    updated = true;
  }
  if (book.firstUpdateId !== data.firstUpdateId) {
    book.firstUpdateId = data.firstUpdateId;
    updated = true;
  }


  return updated ? newState : state; // new object triggers render
};

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.CLEAR_DEPTH_DATA:
      return handleClearDepthData(state, action);
    // clear and update depth and trades after fetching.
    case actionTypes.SET_DEPTH_DATA:
      state = handleClearDepthData(state, action);
      return handleUpdateDepthData(state, action);
    default:
      return state;
  }
};
